import { giphyLightGrey } from '@giphy/colors'
import styled from 'styled-components'
import { fileSizeToDisplayText, secondsToShortDisplayText } from '../../../../utils/text-utils'
import { PillBlock } from '../../../blocks'
import { Subtitle } from '../../../typography'

const Block = styled.div`
    color: ${giphyLightGrey};
    display: inline-block;
    margin-right: 15px;

    &:last-child {
        margin-right: 0;
    }
`

type Props = {
    className?: string
    size: number
    duration: number
    captureCount: number
}

const CreationCaptureInfoPills = ({ className, size, duration, captureCount }: Props) => (
    <div className={className}>
        <Block>
            <Subtitle>Size</Subtitle>
            <PillBlock>{size ? fileSizeToDisplayText(size) : 'Unknown'}</PillBlock>
        </Block>
        <Block>
            <Subtitle>Length</Subtitle>
            <PillBlock>{secondsToShortDisplayText(duration)}</PillBlock>
        </Block>
        <Block>
            <Subtitle>Capture Count</Subtitle>
            <PillBlock>{captureCount || 'Not Started'}</PillBlock>
        </Block>
    </div>
)

export default CreationCaptureInfoPills
